import React, { useRef, useState } from 'react';
import NumberFormat from 'react-number-format';
import { productConfig } from 'constants/constants';
import { formatMoney } from 'utils/utils';
import { useProduct } from 'providers/product.provider';
import editIcon from 'assets/svg/edit.svg';

type LoanAmountInputProps = {
    name: string;
    value: number;
    className?: string;
    decimalScale?: number;
    info?: string;
    lastProposal?:number;
    placeholder?: string;
    prefix?: string;
    size?: 'normal' | 'lg';
    onChange:(value: number) => void;
    onBlur?:(value: number) => void;
    onFocus?:() => void;
}

const LoanAmountInput: React.FC<LoanAmountInputProps> = (props: LoanAmountInputProps) => {
    const { info, onChange, value, prefix, lastProposal, className, size = 'normal' } = props;

    const { productBizId, maxNumberOfInstallments, minNumberOfInstallments } = useProduct();
    const { LOAN_AMOUNT } = productConfig(productBizId, maxNumberOfInstallments, minNumberOfInstallments);

    const [focused, setFocus] = useState(false);

    const classes = ['input-text'];
    const containerClasses = ['loan-amount-input-container'];

    const valueInput = useRef(null);

    let errorMessage = '';

    if (className) {
        containerClasses.push(className);
    }

    if (value) {
        containerClasses.push('filled');
    }

    if (Number(value) > lastProposal) {
        containerClasses.push('error');
        errorMessage = 'O valor é superior ao pré-aprovado.';
    }

    if (Number(value) < LOAN_AMOUNT.MIN()) {
        containerClasses.push('error');
        errorMessage = `O valor pedido deve ser maior que R$ ${formatMoney(LOAN_AMOUNT.MIN())}.`;
    }

    if (size === 'lg') {
        containerClasses.push('input-lg');
    }

    if (focused) {
        containerClasses.push('focus');
    }

    return (
        <div className="input-text-container">
            <div className={containerClasses.join(' ')}>
                <NumberFormat
                    className={classes.join(' ')}
                    onValueChange={({ floatValue }) => onChange(floatValue ? parseFloat(floatValue.toString().substr(0, 6)) : 0)}
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                    value={Number(value) === 0 ? null : value}
                    prefix={prefix}
                    type="tel"
                    thousandSeparator="."
                    decimalSeparator=","
                    allowNegative={false}
                    getInputRef={valueInput}
                />

                <button
                    className="show-edit-button"
                    type="button"
                    onClick={() => {
                        setFocus(true);
                        valueInput.current.focus();
                    }}>
                    <img src={editIcon} />
                </button>

                <span className="bottom" />
                { errorMessage && <span className="error-message"> {errorMessage}</span> }
                { info && <div className="info">{info}</div> }
            </div>
        </div>
    );
}

export default LoanAmountInput;
